<template>
  <BaseContainer class="dnnCloud-account-box" :loading="listLoading" :isHasPageFt="!listLoading">
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="souchs.proName" placeholder="产品名称" @keyup.enter.native="getProList(1)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getProList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="handleAdd" class="adds">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </template>

    <template v-slot:main>
      <!--列表-->
      <el-table tooltip-effect="dark" :data="proList" highlight-current-row v-loading="listLoading" style="width: 100%;" :height="maxTbHeight" @selection-change="selsChange" :header-cell-style="getRowClass" @sort-change="handleSortChange">
        <el-table-column type="index" :index="indexMethod" label="序号" width="100">
          <template slot-scope="scope">
            <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="logo2" header-align="center" align="center" width="200px" label="图片" show-overflow-tooltip>
          <template slot-scope="scope">
            <img slot="reference" :src="scope.row.logo2" :alt="scope.row.logo2" class="tpimg">
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品名称" min-width="240" sortable="custom" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="price" label="单价(元/月)" min-width="150" sortable="custom" show-overflow-tooltip></el-table-column>

        <el-table-column prop="purchasabled" label="是否可购买" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="myTag primary">{{ scope.row.purchasable == 1? "否": '是' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="useful" label="是否作废" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="myTag primary">{{ scope.row.useful == 1? "否": '是' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="220" style="text-algin:center">
          <template slot-scope="scope">
            <span class="operate">
              <el-tooltip effect="dark" content="编辑" placement="top">
                <span class="dnnfont iconEdit" @click="handleEdit(scope.$index, scope.row)"></span>
              </el-tooltip>

              <el-tooltip effect="dark" content="删除" placement="top">
                <span class="dnnfont icondelete" @click="handleDel(scope.$index, scope.row)"></span>
              </el-tooltip>
            </span>
            <!-- <el-button type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!--新增界面-->
      <el-dialog class="model-edit" title="新增产品" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="22">
              <el-form-item label="图片" required>
                <el-upload ref="upload" :auto-upload="false" :on-change="imgPreview" class="avatar-uploader" :action="upload.postURL" :show-file-list="false">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="名称" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="单价" prop="price">
                <el-input style="width:217px;" placeholder="请输入" v-model="addForm.price" @blur="priceLose(1)"></el-input> 元/月
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="可购买" prop="purchasable">
                <el-select v-model="purchasable">
                  <el-option v-for="item in gms" :label="item.text" :key="item.value" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="是否废弃" prop="useful">
                <el-select v-model="useful">
                  <el-option v-for="item in usefulLists" :label="item.text" :key="item.value" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="产品模块">
                <div class="mk_div" style="width: 100%">
                  <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox class="mk_elbox" v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--编辑界面-->
      <el-dialog class="model-edit" title="编辑产品" :visible.sync="editFormVisible" :close-on-click-modal="false" @closed="closeDialog">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-row>
            <el-col :span="22">
              <el-form-item label="图片" required>
                <el-upload ref="upload" :auto-upload="false" :on-change="imgPreview" class="avatar-uploader" :action="upload.postURL" :show-file-list="false">
                  <img v-if="editImageUrl" :src="editImageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="名称" prop="name">
                <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="单价" prop="price">
                <el-input style="width:217px;" placeholder="请输入" v-model="editForm.price" @blur="priceLose(2)"></el-input> 元/月
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="可购买" prop="purchasable">
                <el-select v-model="editForm.purchasable">
                  <el-option v-for="item in gms" :label="item.text" :key="item.value" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="是否废弃" prop="useful">
                <el-select v-model="editForm.useful">
                  <el-option v-for="item in usefulLists" :label="item.text" :key="item.value" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="产品模块">
                <div class="mk_div" style="width: 100%">
                  <el-checkbox-group v-model="editCheckedCities" @change="handleCheckedCitiesChange2">
                    <el-checkbox class="mk_elbox" v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 50,100]" :current-page="pageNumber" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pageSize" :total="total" style="float:right;">
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import { currency } from '../../../common/js/currency'
import axios from 'axios'
import { API__code, API_Product, API_Models, API_Common, imgURLs } from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  filters: {
    currency: currency,
  },
  inject: ['reload'],
  data() {
    return {
      orderType: '',
      orderStr: '',
      beformAddImg: '',
      editFormVisible: false,
      editForm: {
        useful: '1',
      },
      editLoading: false,
      editImageUrl: '',
      // editModule:'',
      editFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        purchasable: [{ required: true, message: '请选择可购买', trigger: 'blur' }],
        useful: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      imgs: '',
      userModule: [],
      logo: '',
      cities: [],
      citiesd: [],
      checkedCities: [],
      editCheckedCities: [],
      souchs: {},
      checkCode: '',
      token: '',
      proList: [],
      listLoading: false,
      pageSize: 20,
      pageNumber: 1,
      total: 0,

      addFormVisible: false,
      addForm: {},
      purchasable: '0',
      useful: '1',
      addFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        purchasable: [{ required: true, message: '请选择', trigger: 'blur' }],
        useful: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      addLoading: false,
      gms: [
        { value: '0', text: '是' },
        { value: '1', text: '否' },
      ],

      // 是否废弃
      usefulLists: [
        { value: '0', text: '废弃' },
        { value: '1', text: '正常' },
      ],

      editFormVisible: false,

      imageUrl: '',
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: API_Common.setLoglist(), //post地址
        dialogImageUrl: '', // 文件地址
        dialogVisible: false, // 上传文件loading
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1,
        },
      },
      changFalg: false,
    }
  },

  computed: {
    ...mapGetters(['userInfo']),
  },

  components: {
    BaseContainer,
  },

  methods: {
    priceLose: function (val) {
      var newPrice
      if (val == 1) {
        newPrice = this.addForm.price
      } else {
        newPrice = this.editForm.price
      }
      if (newPrice) {
        if (isNaN(newPrice)) {
          newPrice = newPrice.replace(/[^\.\d]/g, '')
        }
        if (parseFloat(newPrice).toString() == 'NaN') {
          this.$message.error('指标数为大于0的数, 请重新输入')
          return
        } else if (newPrice < 0) {
          this.$message.error('指标数为大于0的数, 请重新输入')
          newPrice = 0
          return
        } else {
          newPrice = parseFloat(newPrice)
          newPrice = newPrice.toLocaleString()
        }
      } else {
        newPrice = 0
      }
      if (val == 1) {
        this.addForm.price = newPrice
      } else {
        this.editForm.price = newPrice
      }
    },
    imgPreview(file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file
        // this.imageUrl =  file.url;
        // this.editImageUrl = file.url;
        this.imageUrl = URL.createObjectURL(file.raw)
        this.editImageUrl = URL.createObjectURL(file.raw)
      } else {
        this.$message.error('请选择图片文件')
      }
    },
    closeDialog() {
      this.$refs['editForm'].clearValidate()
    },
    editSubmit: function () {
      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error('请上传图片!')
        return
      }
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          if (this.beformAddImg) {
            console.log('xxxxxx')
            let var_this = this
            let formData = new FormData()
            formData.append('pic', this.beformAddImg.raw)
            formData.append('token', this.token)
            formData.append('checkCode', this.checkCode)
            formData.append('oldpicid', this.editForm.picid)
            formData.append('mode', 'save')
            let config = {
              'Content-Type': 'multipart/form-data',
            }
            axios
              .post(this.upload.postURL, formData, config)
              .then(function (res) {
                if (res.data.code == API__code.SUCCESS) {
                  var_this.editSave(res.data.data)
                  var_this.$refs.upload.clearFiles()
                } else {
                  var_this.$message.error(res.data.message)
                  if (res.data.code == 403) {
                    var_this.$router.push({ path: 'loginAdmin' })
                  }
                  return
                }
              })
              .catch(function (error) {
                console.log(error)
                return
              })
          } else {
            this.editSave()
          }
        }
      })
      // if(this.userModule.length > 0){
      //   this.userModule = JSON.stringify(this.userModule);
      // }else if(!this.changFalg){
      //   this.userModule = this.editForm.module;
      // }

      // if(!this.editForm.name){
      //   this.$message.error("请输入名称!");
      //   return;
      // }
      // if(!this.editForm.price){
      //   this.$message.error("请输入单价!");
      //   return;
      // }
      // if(!this.editForm.purchasable){
      //   this.$message.error("请选择可购买!");
      //   return;
      // }
      // if(this.userModule.length < 1){
      //   this.$message.error("请选择产品模块!");
      //   return;
      // }
    },
    editSave: function (val) {
      if (val) {
        // this.editForm.logo = val.projectPath + val.pic;
        this.editForm.logo = val.pic
        this.editForm.picid = val.id
      }
      if (isNaN(this.editForm.price)) {
        this.editForm.price = this.editForm.price.replace(/[^\.\d]/g, '')
      }
      let param
      param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        name: this.editForm.name,
        price: this.editForm.price,
        purchasable: this.editForm.purchasable,
        module: JSON.stringify(this.userModule),
        picid: this.editForm.picid,
        useful: this.editForm.useful,
      }
      // return;
      this.editLoading = true
      API_Product.setProductList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: '修改成功',
              type: 'success',
            })
            this.getProList()
            this.editFormVisible = false
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' })
            }
          }
          this.editLoading = false
        })
        .catch((err) => {
          this.$message.error('数据丢失，试试重新登陆！')
          this.editLoading = false
        })
    },
    // uploadSuccess(response, file, fileList) {
    //   if(response.pic){
    //     this.logo = "http://192.168.100.230:8080/dnnCloud/" + response.pic;
    //     // this.logo = "http://106.14.238.88:8080/dnnCloud/" + response.pic;
    //   }
    //   this.upload.picIds.push(response.id);
    //   this.imageUrl = URL.createObjectURL(file.raw);
    //   this.editImageUrl = URL.createObjectURL(file.raw);

    // },
    // submitUpload: function(content) {//自定义的上传图片的方法
    //   var self = this;
    //   var file = content.file;
    //   var fileType = file.type;
    //   var isImage = fileType.indexOf('image') != -1;
    //   // var file_url = this.$refs.upload.uploadFiles[0].url;
    //   if(!isImage){
    //       this.$message.error("请上传图片！");
    //       this.$refs.upload.clearFiles();
    //       return;
    //   }
    //   let formData = new FormData;
    //   formData.append('pic', content.file);
    //   formData.append('token', this.token);
    //   formData.append('checkCode', this.checkCode);
    //   formData.append('mode', 'save');
    //   let config = {
    //       'Content-Type': 'multipart/form-data'
    //   }
    //   let var_this = this;
    //   axios.post(this.upload.postURL, formData, config)
    //     .then(function(response) {
    //         if (response.data.code == API__code.SUCCESS) {
    //           //  this.uploadPreview(response.data.data)
    //             content.onSuccess(response.data.data);
    //             var_this.$message({
    //                 message: "上传成功",
    //                 type: 'success'
    //             });
    //         }else{
    //           var_this.$message.error(response.data.message);
    //           if(response.data.code == 403){
    //             var_this.$router.push({path: 'loginAdmin'});
    //           }
    //         }
    //     })
    //     .catch(function(error) {
    //         console.log(error);
    //     })

    // },
    handleCheckedCitiesChange(value) {
      this.userModule = []
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = {
              id: this.citiesd[k].id,
              modulename: this.citiesd[k].modulename,
              moduleid: this.citiesd[k].moduleid,
            }
            this.userModule.push(jsoned)
          }
        }
      }
    },
    handleCheckedCitiesChange2(value) {
      console.log('value===', value)
      this.changFalg = true
      this.userModule = []
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = {
              id: this.citiesd[k].id,
              modulename: this.citiesd[k].modulename,
              moduleid: this.citiesd[k].moduleid,
            }
            console.log(jsoned)
            this.userModule.push(jsoned)
          }
        }
      }
    },
    addSubmit: function () {
      let var_this = this
      if (!this.addForm.name) {
        this.$message.error('请输入名称!')
        return
      }
      if (!this.addForm.price) {
        this.$message.error('请输入单价!')
        return
      }
      if (!this.beformAddImg) {
        this.$message.error('请上传图片!')
        return
      }
      if (!this.purchasable) {
        this.$message.error('请选择可购买!')
        return
      }
      if (this.userModule.length < 1) {
        this.$message.error('请选择产品模块!')
        return
      }
      let formData = new FormData()
      formData.append('pic', this.beformAddImg.raw)
      formData.append('token', this.token)
      formData.append('checkCode', this.checkCode)
      formData.append('mode', 'save')
      let config = {
        'Content-Type': 'multipart/form-data',
      }
      axios
        .post(this.upload.postURL, formData, config)
        .then(function (res) {
          if (res.data.code == API__code.SUCCESS) {
            var_this.addSave(res.data.data)
            var_this.$refs.upload.clearFiles()
          } else {
            var_this.$message.error(res.data.message)
            if (res.data.code == 403) {
              var_this.$router.push({ path: 'loginAdmin' })
            }
            return
          }
        })
        .catch(function (error) {
          console.log(error)
          return
        })
    },
    addSave: function (val) {
      // var newlbtPath = val.projectPath + val.pic;
      var newlbtPath = val.pic
      // var newlbtsltUrl = val.projectPath + val.sltUrl;
      var newId = val.id
      if (isNaN(this.addForm.price)) {
        this.addForm.price = this.addForm.price.replace(/[^\.\d]/g, '')
      }
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        name: this.addForm.name,
        price: this.addForm.price,
        purchasable: this.purchasable,
        module: JSON.stringify(this.userModule),
        logo: newlbtPath,
        picid: newId,
        useful: this.useful,
      }
      this.addLoading = true
      API_Product.setProductList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: '添加成功',
              type: 'success',
            })
            this.purchasable = '0'
            this.addFormVisible = false
            this.getProList()
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' })
            }
          }
          this.addLoading = false
        })
        .catch((err) => {
          this.$message.error('数据丢失，试试重新登陆！')
          this.addLoading = false
        })
    },
    handleAdd: function () {
      this.addFormVisible = true
      this.imageUrl = ''
      this.addForm = {}
      this.beformAddImg = ''
      this.userModule = []
      this.logo = ''
      this.checkedCities = []
    },
    handleSortChange: function (val) {
      if (val) {
        if (val.prop == 'name') {
          this.orderStr = 'namepx'
        } else if (val.prop == 'purchasabled') {
          this.orderStr = 'purchasabledpx'
        } else if (val.prop == 'price') {
          this.orderStr = 'pricepx'
        }
        if (val.order == 'descending') {
          this.orderType = 'desc'
        } else {
          this.orderType = 'asc'
        }
      }
      this.getProList()
    },
    getProList: function (val) {
      if (val == 1) {
        this.pageNumber = 1
      }
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        nameStr: this.souchs.proName,

        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
      }
      this.listLoading = true
      API_Product.productList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.total = res.data.data.totalRow
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].purchasable) {
                if (res.data.data.list[i].purchasable == 0) {
                  res.data.data.list[i].purchasabled = '是'
                } else {
                  res.data.data.list[i].purchasabled = '否'
                }
              }
              if (res.data.data.list[i].logo) {
                res.data.data.list[i].logo2 = res.data.data.list[i].logo
              }

              if (res.data.data.list[i].price) {
                // res.data.data.list[i].price = (res.data.data.list[i].price.toString()).getAns();
                res.data.data.list[i].price = parseFloat(res.data.data.list[i].price)
                res.data.data.list[i].price = res.data.data.list[i].price.toLocaleString()
              } else {
                res.data.data.list[i].price = 0
              }
            }
            this.proList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' })
            }
          }
          this.listLoading = false
        })
        .catch((err) => {
          this.$message.error('数据丢失，试试重新登陆！')
          this.listLoading = false
        })
    },
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return 'background:#F5F7FA'
      } else {
        return ''
      }
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getProList()
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getProList()
    },
    handleEdit: function (index, row) {
      this.userModule = []
      this.beformAddImg = ''
      this.editFormVisible = true
      this.editForm = Object.assign({}, row)
      console.log('this.editForm==', this.editForm)
      // this.editModule = row.module;
      var cc = JSON.parse(row.module)
      console.log('cc=', cc)
      this.userModule = cc;
      this.editCheckedCities = []
      this.logo = ''
      for (var i = 0; i < cc.length; i++) {
        this.editCheckedCities.push(cc[i].modulename)
      }
      this.editImageUrl = row.logo2
    },

    //删除
    handleDel: function (index, row) {
      this.$confirm('确认删除该产品吗?', '提示', {
        type: 'warning',
      }).then(() => {
        let para = {
          id: row.id,
          picid: row.picid,
          token: this.token,
          checkCode: this.checkCode,
        }
        API_Product.delProductList(para)
          .then((res) => {
            if (res.data.code == API__code.SUCCESS) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
              this.getProList()
              // this.reload();
            } else {
              this.$message.error(res.data.message)
              if (res.data.code == 403) {
                this.$router.push({ path: 'loginAdmin' })
              }
            }
          })
          .catch((err) => {
            this.$message.error('数据丢失，试试重新登陆！')
          })
      })
    },
    getModuleList: function () {
      let _this = this
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        //searchModuleName:this.souchs.modelName,
        // listType:'page',
        // pageNumber:this.pageNumber,
        // pageSize:this.pageSize,
      }
      API_Models.getAdminModule(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.models = res.data.data
            this.cities = []
            this.citiesd = []
            for (var i = 0; i < res.data.data.length; i++) {
              _this.cities.push(res.data.data[i].modulename)
              var jsones = {
                modulename: res.data.data[i].modulename,
                id: res.data.data[i].id,
                moduleid: res.data.data[i].moduleid,
              }
              _this.citiesd.push(jsones)
            }
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' })
            }
          }
        })
        .catch((err) => {
          this.$message.error('数据丢失，试试重新登陆！')
        })
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1]
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1]
          }
        }
      }
    },
  },
  created() {
    this.getCookie()
  },
  mounted() {
    this.getProList()
    this.getModuleList()
  },
}
</script>
<style lang="scss">
.dnnCloud-product-box {
}
</style>
<style>
.tpimg {
  max-height: 30px;
  max-width: 130px;
  position: relative;
  top: 5px;
}
.mk_div {
  background: #fff;
  width: 70%;
  height: 200px;
  overflow: auto;
  border: 1px solid #dfe6ec;
}
.mk_elbox {
  float: left;
  clear: left;
  margin-left: 15px;
  position: relative;
  top: 0px;
}
.avatar-uploader {
  line-height: 0px;
}
.model-edit .el-dialog__body {
  padding: 30px 20px 0 20px;
}
</style>




// WEBPACK FOOTER //
// ProductList.vue?b893b0a2